module.exports = __webpack_public_path__ + "img/tree-4.dd631434.png";